/* Fine Wines Health — Klaviyo client-side list subscribe.
   Uses the PUBLIC company id (safe to expose). No private key here. */
(function () {
  var COMPANY_ID = "UCVYtc";
  window.FW_KLAVIYO_LISTS = { community: "Xw2kH9", newsletter: "QSGAWs" };

  window.fwKlaviyoSubscribe = function (listId, profile) {
    profile = profile || {};
    if (!profile.email) return Promise.reject(new Error("email required"));
    var props = {};
    if (profile.first_name) props.$first_name = profile.first_name;
    if (profile.last_name) props.$last_name = profile.last_name;
    if (profile.phone) props.phone = profile.phone;          // stored as a property (avoids strict E.164 validation)
    if (profile.source) props.signup_source = profile.source;
    var body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: profile.source || "Website",
          profile: {
            data: {
              type: "profile",
              attributes: { email: profile.email, properties: props }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: listId } } }
      }
    };
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY_ID, {
      method: "POST",
      headers: { "revision": "2024-10-15", "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
  };
})();
